import axios from 'axios';

// 创建axios实例
const api = axios.create({
  baseURL: 'https://api.xibaihui.cn/', // 基础URL
  timeout: 10000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json'
  }
});

// 请求拦截器
api.interceptors.request.use(
  config => {
    // 可以在这里添加token等认证信息
    // 例如: config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截器
api.interceptors.response.use(
  response => {
    // 统一处理响应结果
    const data = response.data;
    
    // 检查是否是统一格式的响应
    if (data.code !== undefined) {
      // 如果code是200，返回data字段
      if (data.code === 200) {
        return data.data;
      } else {
        // 如果code不是200，视为错误，直接使用msg作为错误信息
        console.error('操作失败:', data.msg);
        const error = new Error(data.msg || '操作失败');
        error.code = data.code;
        error.msg = data.msg || '操作失败'; // 添加msg属性
        return Promise.reject(error);
      }
    } else {
      // 如果不是统一格式，直接返回数据
      return data;
    }
  },
  error => {
    // 处理错误响应
    if (error.response) {
      // 服务器返回错误状态码
      console.error('服务器错误:', error.response.status, error.response.data);
      
      // 检查是否是统一格式的错误响应
      if (error.response.data && error.response.data.code !== undefined) {
        const errorMsg = error.response.data.msg || '操作失败';
        console.error('操作失败:', errorMsg);
        const errorObj = new Error(errorMsg);
        errorObj.code = error.response.data.code;
        errorObj.msg = errorMsg; // 添加msg属性
        return Promise.reject(errorObj);
      }
    } else if (error.request) {
      // 请求发送成功但没有收到响应
      console.error('网络错误:', error.request);
      const networkError = new Error('网络错误，请检查网络连接');
      networkError.msg = '网络错误，请检查网络连接'; // 添加msg属性
      return Promise.reject(networkError);
    } else {
      // 请求配置错误
      console.error('请求错误:', error.message);
      return Promise.reject(error);
    }
    
    return Promise.reject(error);
  }
);

// 封装GET请求
export const get = (url, params = {}) => {
  return api.get(url, { params });
};

// 封装POST请求
export const post = (url, data = {}) => {
  return api.post(url, data);
};

// 封装PUT请求
export const put = (url, data = {}) => {
  return api.put(url, data);
};

// 封装DELETE请求
export const del = (url, params = {}) => {
  return api.delete(url, { params });
};

// 用户相关API
export const userApi = {
  // 发送验证码
  sendVerificationCode: (phone, type = 4) => {
    return post('/sysOfficialWebsiteUser/getCode', { phone, type });
  },
  // 用户注册
  register: (data) => {
    return post('/sysOfficialWebsiteUser/register', data);
  },
  // 用户登录
  login: (data) => {
    return post('/sysOfficialWebsiteUser/login', data);
  },
  // 获取微信登录二维码
  getWechatQRCode: () => {
    return get('/sysOfficialWebsiteUser/wechat/getQRCode');
  },
  // 微信登录
  wechatLogin: (data) => {
    return post('/sysOfficialWebsiteUser/wechat/login', data);
  },
  // 重置密码
  resetPassword: (data) => {
    return post('/sysOfficialWebsiteUser/resetPassword', data);
  }
};

// 支付相关API
export const payApi = {
  // 获取支付二维码
  getPayQRCode: (data) => {
    return post('/pay/qrCode', data);
  }
};

export default api;